module.exports = __webpack_public_path__ + "static/img/蒙版组 302@2x.88d65983.png";